import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";
import { CommonTLFModule } from '../../common/common.module';
import { FormAppelloComponent } from './form-appello/form-appello.component';
import { FormAppelloViewComponent } from "./form-appello/view/form-appello-view.component";
import { FormOpposizioneDiTerzoComponent } from './form-opposizione-di-terzo/form-opposizione-di-terzo.component';
import {
  FormOpposizioneDiTerzoViewComponent
} from "./form-opposizione-di-terzo/view/form-opposizione-di-terzo-view.component";
import { FormOrdinarioComponent } from "./form-ordinario/form-ordinario.component";
import { FormOrdinarioViewComponent } from "./form-ordinario/view/form-ordinario-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from './form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "./form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import { FormRevocazioneComponent } from './form-revocazione/form-revocazione.component';
import { FormRevocazioneViewComponent } from "./form-revocazione/view/form-revocazione-view.component";
import { FormRicorsoAlTarComponent } from './form-ricorso-al-tar/form-ricorso-al-tar.component';
import { FormRicorsoAlTarViewComponent } from "./form-ricorso-al-tar/view/form-ricorso-al-tar-view.component";
import { FormRicorsoGerarchicoComponent } from './form-ricorso-gerarchico/form-ricorso-gerarchico.component';
import {
  FormRicorsoGerarchicoViewComponent
} from "./form-ricorso-gerarchico/view/form-ricorso-gerarchico-view.component";
import { FormRicorsoLavoroComponent } from './form-ricorso-lavoro/form-ricorso-lavoro.component';
import { FormRicorsoLavoroViewComponent } from './form-ricorso-lavoro/view/form-ricorso-lavoro-view.component';
import { FormRicorsoOpposizioneComponent } from './form-ricorso-opposizione/form-ricorso-opposizione.component';
import {
  FormRicorsoOpposizioneViewComponent
} from "./form-ricorso-opposizione/view/form-ricorso-opposizione-view.component";
import {
  FormRicorsoStraordinarioPresidenterepComponent
} from './form-ricorso-straordinario-presidenterep/form-ricorso-straordinario-presidenterep.component';
import {
  FormRicorsoStraordinarioPresidenterepViewComponent
} from "./form-ricorso-straordinario-presidenterep/view/form-ricorso-straordinario-presidenterep-view.component";
import { FormRicorsoAmministrativoComponent } from './form-ricorso/form-ricorso.component';
import { FormRicorsoAmministrativoViewComponent } from './form-ricorso/view/form-ricorso-view.component';
import { FormSpecialeComponent } from "./form-speciale/form-speciale.component";
import { FormSpecialeViewComponent } from "./form-speciale/view/form-speciale-view.component";
import { DynamicComponentService } from "./services/dynamic-component.service";
import { FormGenericoComponent } from './form-generico/form-generico.component';
import { FormGenericoViewComponent } from './form-generico/view/form-generico-view.component';

@NgModule({
    imports: [CommonTLFModule, CommonModule, RouterModule, NgbModule, FormsModule, ReactiveFormsModule, TagInputModule, NgSelectModule],
    declarations: [
        FormAppelloComponent,
        FormAppelloViewComponent,
        FormOpposizioneDiTerzoComponent,
        FormOpposizioneDiTerzoViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent,
        FormRevocazioneComponent,
        FormRevocazioneViewComponent,
        FormRicorsoAlTarComponent,
        FormRicorsoAlTarViewComponent,
        FormRicorsoGerarchicoComponent,
        FormRicorsoGerarchicoViewComponent,
        FormRicorsoOpposizioneComponent,
        FormRicorsoOpposizioneViewComponent,
        FormRicorsoStraordinarioPresidenterepComponent,
        FormRicorsoStraordinarioPresidenterepViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormRicorsoAmministrativoComponent,
        FormRicorsoAmministrativoViewComponent,
        FormSpecialeComponent,
        FormSpecialeViewComponent,
        FormRicorsoLavoroComponent,
        FormRicorsoLavoroViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
    ],
    providers: [DynamicComponentService],
    exports: [
        FormAppelloComponent,
        FormAppelloViewComponent,
        FormOpposizioneDiTerzoComponent,
        FormOpposizioneDiTerzoViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent,
        FormRevocazioneComponent,
        FormRevocazioneViewComponent,
        FormRicorsoAlTarComponent,
        FormRicorsoAlTarViewComponent,
        FormRicorsoGerarchicoComponent,
        FormRicorsoGerarchicoViewComponent,
        FormRicorsoOpposizioneComponent,
        FormRicorsoOpposizioneViewComponent,
        FormRicorsoStraordinarioPresidenterepComponent,
        FormRicorsoStraordinarioPresidenterepViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormRicorsoAmministrativoComponent,
        FormRicorsoAmministrativoViewComponent,
        FormSpecialeComponent,
        FormSpecialeViewComponent,
        FormRicorsoLavoroComponent,
        FormRicorsoLavoroViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
    ]
})
export class FascicoloFormSharedModule {

}
